(function() {
  'use strict';

  function GoalsController(
    $scope, $rootScope, $log, Auth, GoalsStore, OrganisationsService, Utils, Profile
  ) {
    var ctrl = this;
    ctrl.listOptions = {
      noItemsText: 'There have been no goals created yet.'
    };

    ctrl.$onChanges = function() {
      if (ctrl.filterId) {
        ctrl.resolvedTitle = '';
        OrganisationsService.getFilter('epf.goals.index', ctrl.filterId)
          .then(function(data) {
            ctrl.resolvedFilter = data;
            ctrl.resolvedTitle = data.name || 'Goals';
            ctrl.setup();
          })
          .catch(function(error) {
            $log.warn(error);
          });
      } else {
        ctrl.resolvedTitle = 'Goals';
        ctrl.setup();
      }
    };

    ctrl.setup = function() {
      var listName = ctrl.resolvedFilter ? 'goals-' + ctrl.resolvedFilter.id : 'goals';

      ctrl.searchModel = Profile.getListPreferences(listName).current;
      ctrl.options = { search: ctrl.searchModel };

      var defaultFilter = (ctrl.resolvedFilter || {}).filter || {};
      defaultFilter.user = Auth.currentUser();

      Utils.setPageTitle('Goals');

      GoalsStore.getList(defaultFilter, ctrl.searchModel)
        .then(function(list) {
          ctrl.list = list;
          ctrl.loaded = true;
          $rootScope.$broadcast('KZCurrentListChange',
            { list: listName, search: ctrl.list.search }
          );
        })
        .catch(function(error) {
          Utils.showError(error);
        });

      // get all current period and show only needed goals + targets.
    };

    $scope.$on('GoalPeriodSelected', function(_evt, periodFilter) {
      $log.debug('Some period selected');
      $scope.$broadcast('GoalPeriodUpdated', periodFilter);
    });
  }

  GoalsController.$inject = ['$scope', '$rootScope', '$log', 'AuthService', 'GoalsStore',
    'OrganisationsService', 'UtilsService', 'ProfileService'];

  angular.module('component.goals')
    .component('goalsListComponent', {
      controller: GoalsController,
      controllerAs: 'goalsCtrl',
      templateUrl: 'app/components/goals/list.html',
      bindings: {
        filterId: '<'
      }
    });
})();
